export default str => {
  return str.toLowerCase();
};
